import { useMutation, useQueryClient } from "@tanstack/react-query";
import { impersonateUser } from "../api/impersonationApi";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export const useImpersonation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate: impersonate, isPending: isImpersonating } = useMutation({
    mutationFn: impersonateUser,
    onSuccess: (data) => {
      if (data.token) {
        localStorage.setItem("token", data.token);
        const decoded = jwtDecode(data.token);
        queryClient.setQueryData(["authStatus"], {
          isAuthenticated: true,
          role: decoded.role,
          impersonatedBy: decoded.impersonatedBy,
        });
        toast.success(data.message || "Impersonation successful!");
        // Navigate to the correct dashboard based on role
        if (decoded.role === "SuperAdmin") {
          navigate("/super-admin-dashboard");
          window.location.reload();
        } else if (decoded.role === "Admin" || decoded.role === "Manager") {
          navigate("/project-admin");
          window.location.reload();
        } else if (decoded.role === "Agent") {
          navigate("/agent-admin?tab=Listings");
          window.location.reload();
        } else if (decoded.role === "public") {
          navigate("/user-dashboard");
          window.location.reload();
        } else {
          navigate("/");
          window.location.reload();
        }
      } else {
        toast.error("No token returned for impersonation");
      }
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Impersonation failed!");
    },
  });

  return { impersonate, isImpersonating };
};
